<div class="row">
    <div class="col-lg-12 grid-margin">
        <div class="card">
            <div class="card-body upper-header">
                <div class="row">
                    <div class="form-group col-2 ">
                        <label>From Date</label>
                        <input class="form-control border-primary" [max]="to_date" [owlDateTime]="dt" placeholder="Date"
                            name="from_date" [(ngModel)]="from_date" readonly>
                        <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                        <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                    </div>
                    <div class="form-group col-2 ">
                        <label>To Date</label>
                        <input class="form-control border-primary" [min]="from_date" [max]="maxDate" [owlDateTime]="dt1"
                            placeholder="Date" name="to_date" [(ngModel)]="to_date" readonly>
                        <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
                        <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                    </div>

                    <div class="p-2 d-flex align-items-center ml-4">
                            <div class="mr-3 " style="margin-top: 10px;">
                                <input
                                class="form-check-input"
                                type="checkbox"
                                id="actionTaken"
                                [(ngModel)]="actionTaken" style="accent-color: #ddd;">
                                <label class="form-check-label" for="actionTaken" style="font-weight: 600; font-size: 14px; color: #333; cursor: pointer; margin-left: 2px; vertical-align: middle; padding-left: 0;">
                                Action Taken
                                </label>
                            </div>
                        </div>

                    <div class="form-group col-1.5">
                        <button type="button" style="margin-top: 30px;"
                            class="btn btn-primary btn-fw top-btn-head" (click)="getList($event)">Load</button>
                    </div>
                </div>
               
                <h4 class="card-title">
                    <div class="d-flex bd-highlight align-items-center">
                        <div class="p-2 flex-grow-1 bd-highlight">Contact Inquiries</div>
                        <div class="p-2" style="width: 300px;">
                            <input type="text" class="form-control" placeholder="Search Name, mobile, etc."
                                [(ngModel)]="search" (keyup)="onSearchChange()">
                        </div>
                        
                        <div class="p-2">
                            <button type="button" class="btn btn-primary btn-fw top-btn-head" (click)="exportList()">Export</button>
                        </div>
                    </div>
                </h4>
                <div class="table-responsive"
                    *ngIf="inquiriesList && inquiriesList.data && inquiriesList.data.length">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Date</th>
                                <th>Mobile Number</th>
                                <th>Email </th>
                                <th style="max-width: 200px;">Message</th>
                                <th>Action </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of inquiriesList?.data; let i = index">
                                <td>
                                    <span *ngIf="page == 1">{{i+1}}</span>
                                    <span *ngIf="page > 1">{{((page - 1 )* perPage) + (i+1)}}</span>
                                </td>
                                <td>{{data?.full_name}}</td>
                                <td>{{data?.created_at | date:'dd-MM-yyyy'}}</td>
                                <td>{{data?.mobile_no}}</td>
                                <td>{{data?.email}}</td>
                                <td style="max-width: 200px;text-wrap: auto;">{{data?.message}}</td>
                                <td>
                                    <span *ngIf="data.action_taken == false" (click)="openActionModal(actionModal, data.id)">
                                        <i class="fa fa-check-circle" title="Take Action" aria-hidden="true"></i>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="p-12" *ngIf="inquiriesList && inquiriesList.data && !inquiriesList.data.length">
                    <span class="ng-star-inserted no_data">No Data found.</span>
                </div>
                <ngb-pagination *ngIf="inquiriesList && inquiriesList.data && inquiriesList.data.length" [collectionSize]="totalCount" [pageSize]="perPage"
          [(page)]="page" (pageChange)="getList('pagination')" [maxSize]="3"
          class="pull-right justify-content-end page-mt-10"
          aria-label="Default pagination"></ngb-pagination>
            </div>
        </div>
    </div>
</div>

<ng-template #actionModal let-modal>
  <div class="modal-body">
    <div class="form-group">
      <label>Remark</label>
      <textarea
        class="form-control"
        rows="4"
        placeholder="Enter remark (optional)"
        [(ngModel)]="actionRemark">
      </textarea>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
    <button class="btn btn-primary" (click)="submitAction(modal)">Submit</button>
  </div>
</ng-template>